import { spinner } from '@/components';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadPersonalizationSummaryPdfButton } from '../Personalization.Summary/Pdf/DownloadPersonalizationSummaryPdfButton';
import { FileExcelOutlined, PieChartOutlined } from '@ant-design/icons';
import { useUserContextSelector } from '@/redux';
import { reportsHttp } from '@/core';
import { browserFileDownload } from '@/utils';
import {
  PERSONALIZATION_SUMMARY_FORM_INITIAL_VALUE,
  PersonalizationSummaryFormValue,
} from '../Personalization.Summary/Pdf/DownloadPersonalizationSummaryPdfModal';

const useSubmit = () => {
  return useCallback(
    (args: PersonalizationSummaryFormValue, onClose: () => void) => {
      spinner.show();
      reportsHttp
        .generatePersonalizationSummary(args)
        .then((file) => {
          browserFileDownload(file);
        })
        .finally(() => {
          onClose();
          spinner.hide();
        });
    },
    [],
  );
};

export function GeneratePersonalizationSummaryReportButton() {
  const { t } = useTranslation();
  const [isBfp, isClient] = useUserContextSelector((x) => [
    x.isBFP,
    x.isClient,
  ]);
  const handleSubmit = useSubmit();
  return (
    <DownloadPersonalizationSummaryPdfButton
      title={t('reports.personalizationSummary.title')}
      openButtonTitle={t('reports.personalizationSummaryReport')}
      openButtonIcon={<PieChartOutlined />}
      downloadButtonTitle={t('reports.personalizationSummary.runReport')}
      downloadButtonIcon={<FileExcelOutlined />}
      layout="two-columns"
      onDownload={handleSubmit}
      initialValue={{
        ...PERSONALIZATION_SUMMARY_FORM_INITIAL_VALUE,
        _required: true,
      }}
      filterBy={[
        'project',
        'home',
        'step',
        'baseCost',
        ...(isBfp ? (['client'] as const) : []),
        ...(isClient || isBfp ? (['community'] as const) : []),
      ]}
    />
  );
}
